<div class="wrapper-chart">
    <div id="chartElement" style="width: 100%; height: 100%"></div>
</div>
